import type { CartBadRequestErrorResponse, CartErrorResponse } from '@libs/common-node';
import type { DeliveryType } from '@libs/core';
import { HttpStatus } from '@libs/core';

export class CartUpdateError extends Error {
    readonly errorDetails: CartBadRequestErrorResponse;
    readonly attemptedFulfillmentMethod?: DeliveryType;

    constructor(message: string, data: CartBadRequestErrorResponse, attemptedFulfillmentMethod?: DeliveryType) {
        super(message);

        this.errorDetails = data;
        this.attemptedFulfillmentMethod = attemptedFulfillmentMethod;
    }
}

export const isCartClientErrorResponse = (
    response: CartErrorResponse | null
): response is CartBadRequestErrorResponse => {
    if (
        !response?.status ||
        !response?.errors ||
        !Array.isArray(response.errors) ||
        response?.status === HttpStatus.UNPROCESSABLE_ENTITY // handled separately in parseErrorResponse
    )
        return false;

    return response.status >= HttpStatus.BAD_REQUEST && response.status < HttpStatus.INTERNAL_SERVER_ERROR;
};
